import { colors } from "constants/colors";
import styled from "styled-components";

export const StyledErrorMessage = styled.div`
  font-size: 14px;
  color: ${colors.error};
  padding-top: 2px;
`;
